import { BaseEntity } from '../base-entity';
import { PbiReport } from './pbi-report';
import { Report } from './report';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContextsActionMap } from '@mri-platform/resource-authz';
/// </code-import>

export interface ReportActivityRecordInfo {
  id: string;
  activityDate: Date;
  activityType: string;
  draftId?: string;
  draftName?: string;
  email?: string;
  reportId: string;
  tenantKey: string;
  userFullName?: string;
  userId?: string;
  userTeam?: string;
  draft: PbiReport;
  report: Report;
}

/// <module-code> Place module level code between <module-code> tags
const typeFuncs = BaseEntity.makeStaticTypeFunctions<ReportActivityRecordInfo>(EntityName.ReportActivityRecordInfo);
/// </module-code>

export class ReportActivityRecordInfo extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static readonly propName = typeFuncs.propName;
  static readonly authorization = AuthzContextsActionMap.crudFor(EntityName.ReportActivityRecord);

  get userFullNameDisplayValue() {
    return this.userFullName ?? '<User Removed>';
  }

  get userTeamDisplayValue() {
    return this.userTeam ?? '<User Removed>';
  }
  /// </code>
  // Generated code. Do not place code below this line.
}
